export class DeletedItem {
  public id: string

  constructor(id: string) {
    this.id = id
  }
}
